export default "__VITE_ASSET__DASSIRkt__"